import { JourneyDetailsStepper, JourneyDetailsWizard, JourneySidebar } from "../components";
import CountdownTimerSlider from "@Components/CountdownTimerSlider/CountdownTimerSlider";
export default function JourneyDetailsWeb() {
  return (
    <div className="relative flex w-full flex-col">
      <div className="flex w-full flex-1 items-center">
        <div className="lg:gap-30 gap-10 bg-background-default border-border-default flex w-full flex-1 items-center justify-center gap-5 justify-self-center border-b p-4">
          <div className="flex-1">
            <JourneyDetailsStepper />
          </div>
        </div>
      </div>
      <div className="sticky top-0 z-30">
        <CountdownTimerSlider />
      </div>
      <div className="lg:px-15 flex w-full items-start justify-between gap-x-4 lg:gap-x-10 gap-y-5 bg-background-minimal p-5 w-full">
        <div className="flex-8 flex min-h-[calc(100dvh-16rem)] w-full flex-col gap-4 ">
          <JourneyDetailsWizard />
        </div>
        <div className="flex-3 relative flex h-full w-full flex-col gap-3 self-stretch">
          <JourneySidebar />
        </div>
      </div>
    </div>
  );
}
